__turbopack_context__.v({
  "appItem": "FormattedMessage-module__LHHVlW__appItem",
  "formattedMessage": "FormattedMessage-module__LHHVlW__formattedMessage",
  "formattedMessage__icon": "FormattedMessage-module__LHHVlW__formattedMessage__icon",
  "formattedMessage__iconActive": "FormattedMessage-module__LHHVlW__formattedMessage__iconActive",
  "formattedMessage__loading": "FormattedMessage-module__LHHVlW__formattedMessage__loading",
  "formattedMessage__md": "FormattedMessage-module__LHHVlW__formattedMessage__md",
  "questionnaireItem": "FormattedMessage-module__LHHVlW__questionnaireItem",
  "questionnaireItemActive": "FormattedMessage-module__LHHVlW__questionnaireItemActive",
  "responseText": "FormattedMessage-module__LHHVlW__responseText",
  "sourceButton": "FormattedMessage-module__LHHVlW__sourceButton",
  "sourceButtonWithText": "FormattedMessage-module__LHHVlW__sourceButtonWithText",
  "sourceLink": "FormattedMessage-module__LHHVlW__sourceLink",
  "sourcesContainer": "FormattedMessage-module__LHHVlW__sourcesContainer",
  "sourcesToggleButton": "FormattedMessage-module__LHHVlW__sourcesToggleButton",
});
